import {createFileRoute} from '@tanstack/react-router';

export const Route = createFileRoute('/_protected/home/statements')({
  staticData: {crumbKey: 'navigation.invoices'},
});
